import Vue from 'vue'

module.exports = {

    token: null,

    intercept: function(request, next) {

        if (typeof window.session_type != 'undefined') {
            var sessionType = window.session_type;
        } else {
            var sessionType = 'normal';
        }

        request.headers.set('SessionType', sessionType);

        next();
    }

};
